import React from 'react'

const GenericWindowPostMessage = (message,content={}) =>{
    window.parent.postMessage(
        JSON.stringify({message, content}),
        '*',
      )
}

export default GenericWindowPostMessage